import { useLocalSearchParams } from 'expo-router';

import { CityToursScreen } from '@/components/riviera/city-tours-screen';

export { generateCityToursStaticParams as generateStaticParams } from '@/lib/detail/city-listings-detail';

// One city's tours, e.g. /en/nice/tours — the landing page for "tours in nice"
// searches. Nested under the city guide (/en/nice) rather than /en/tours/nice,
// because tours/[id] already owns that dynamic segment. Only cities with
// enough tours are exported — see city-listings-detail.ts.
export default function CityToursRoute() {
  const { city } = useLocalSearchParams<{ city: string }>();
  return <CityToursScreen cityId={city ?? ''} />;
}
